/* The DOH axis, centred on the corridor.
 *
 * The corridor is what the planner judges against, so it sits in the middle
 * of the chart whatever the curve does: the axis reaches as far above the
 * corridor as below it, far enough for the furthest point. DOH is never
 * negative, so the ticks start at 0 and the space under it stays empty.
 *
 * The reach follows the bulk of the curve (95th percentile), not its single
 * highest point: one week at 500 days must not flatten the other 64 into a
 * line on the corridor. Such a spike runs off the top; the tooltip still
 * gives its value.
 */

export function dohScale(values: (number | null)[], low: number, high: number) {
  const mid = (low + high) / 2
  const distances = values
    .filter((v): v is number => v !== null && Number.isFinite(v))
    .map((v) => Math.abs(v - mid))
    .sort((a, b) => a - b)
  const typical = distances.length ? distances[Math.floor((distances.length - 1) * 0.95)] : 0
  const reach = Math.max(high - mid, typical) * 1.15 || 1
  const step = niceStep(reach / 3)
  const ticks: number[] = []
  for (let t = 0; t <= mid + reach; t += step) ticks.push(Math.round(t * 100) / 100)
  return { domain: [mid - reach, mid + reach] as [number, number], ticks }
}

function niceStep(x: number): number {
  const power = 10 ** Math.floor(Math.log10(x))
  const f = x / power
  return (f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10) * power
}
